import { CustomFormControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useImportDefaultForms = () =>
  useMutationWithLoading(async (xTENANTID?: string) =>
    new CustomFormControllerApi(getConfigObject()).importDefaultCustomForm(
      xTENANTID
    )
  );
